import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { ToastProvider, withModalContext } from '@jutro/components';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { ServiceManager } from '@jutro/legacy/services';
import { PhoneUtil } from '@xengage/gw-portals-viewmodel-js';
import cx from 'classnames';
import { DatatableUtil, LobIconUtil } from '@xengage/gw-portals-util-js';
import { withViewModelService, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { AccountService } from 'gw-capability-gateway-policy';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages } from 'gw-capability-gateway-quoteandbind-common-react';

import metadata from './Summary.metadata.json5';
import EditAccountDetailsPopUp from './EditAccountDetailsPopUp';
import summaryStyles from './Summary.module.scss';
import messages from '../Accounts.messages';

import { Icon } from '@jutro/legacy/components';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

class SummaryWithoutModalContext extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func.isRequired,
            clone: PropTypes.func.isRequired,
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({}).isRequired
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        intl: PropTypes.shape({
            formatDate: PropTypes.func
        }).isRequired
    };

    static contextType = TranslatorContext;

    state = {
        accountData: '',
        showEditLink: true,
        showNewQuoteButton: false
    };

    componentDidMount = () => {
        const { fromAccountLanding } = this.props;
        this.getShowNewQuoteButton();
        this.setState({
            accountData: fromAccountLanding.accountDetailsData,
        });
        this.hasUserAccesstoEditAccounts();
    };

    hasUserAccesstoEditAccounts = () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'editaccountsummary'
        };
        UserService.hasUserSystemPermission(permissionDTO, authHeader).then(
            (editUserPermission) => {
                this.setState({
                    showEditLink: editUserPermission
                });
            }
        );
    };

    getShowNewQuoteButton = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createsubmission'
        };
        const showNewQuoteButton = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );
        this.setState({ showNewQuoteButton });
    };

    getPolicyTable = () => {
        const { accountData } = this.state;
        const { intl } = this.props;
        const policyArray = accountData.policySummaries;
        return policyArray.map((policyDetails) => {
            return {
                productCode: policyDetails.product.productCode,
                productName: policyDetails.product.productName,
                insuredName: policyDetails.primaryInsuredName,
                displayStatus: policyDetails.displayStatus,
                policyNumber: policyDetails.policyNumber,
                effectiveDate: intl.formatDate(new Date(policyDetails.effective), { year: 'numeric', month: 'short', day: 'numeric' }),
                expirationDate: intl.formatDate(new Date(policyDetails.expiration), { year: 'numeric', month: 'short', day: 'numeric' })
            };
        });
    };

    readValue = (id, path) => {
        const { accountData } = this.state;
        return _.get(accountData, path);
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            displayStatus: translator(messages.displayStatus),
            insuredName: translator(messages.insuredName),
            effectiveDate: translator(messages.effectiveDate),
            expirationDate: translator(messages.expirationDate)
        };
        return <span title={toolTipMessage[property]}>{item[property]}</span>;
    };

    getProductImage = (item) => {
        const icon = LobIconUtil.getFontIcon(item.productCode);
        return (
            <Icon
                icon={icon}
                title={item.productCode}
            />
        );
    };

    getPolicyNoLink = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = translator(messages.policyNumber);
        return (
            <>
                <Link
                    to={`/policies/${item[property]}/summary`}
                    className={cx(summaryStyles.remove_link_style)}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            </>
        );
    };

    showModal = async (accountData) => {
        const translator = this.context;
        const { viewModelService } = this.props
        const result = await this.props.modalContext.showModal(
            <EditAccountDetailsPopUp
                title={translator(messages.editContactDetails)}
                actionBtnLabel={messages.saveChanges}
                cancelBtnLabel={messages.cancel}
                accountData={accountData}
                viewModelService={viewModelService}
            />
        );
        return result;
    }

    handleEditButtonClick = () => {
        const { accountData } = this.state;
        const { authHeader } = this.props;
        const translator = this.context;
        this.showModal(accountData).then(async (requestObj) => {
            const contactVM = await AccountService.updateAccountDetails(requestObj, authHeader);
            this.setState({ accountData: contactVM });
            ToastProvider.toast({
                type: 'success',
                message: translator(messages.savedMessage),
                autoClose: true
            });
        }).catch(_.noop);
    };

    showNewQuoteDialog = (account) => {
        const { history, viewModelService, authHeader } = this.props
        const translator = this.context;
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'secondary',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        this.props.modalContext.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    handleNewQuoteClick = () => {
        const { authHeader } = this.props;
        const {
            accountData: { accountNumber }
        } = this.state;

        if (_.isUndefined(accountNumber)) {
            return;
        }

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add New Quote`);

        const accountDetailsPromise = AccountService.getAccountDetails(accountNumber, authHeader);
        accountDetailsPromise.then((account) => {
            this.showNewQuoteDialog(account);
        });
    };

    getAccountHolderStateandPostalCode = (accountData) => {
        return `${accountData.accountHolder.primaryAddress.state} ${accountData.accountHolder.primaryAddress.postalCode}`;
    };

    getAccountDisplayStatus = (accountData) => {
        return `${accountData.statusDisplayName}`;
    };

    getPhoneNumber = (accountData) => {
        let primaryPhoneNumber = '';
        const localeService = ServiceManager.getService('locale-service');
        const phoneUtil = PhoneUtil();
        switch (accountData.accountHolder.primaryPhoneType) {
            case 'work':
                primaryPhoneNumber = accountData.accountHolder.workNumber;
                break;
            case 'home':
                primaryPhoneNumber = accountData.accountHolder.homeNumber;
                break;
            case 'mobile':
                primaryPhoneNumber = accountData.accountHolder.cellNumber;
                break;
            default:
                primaryPhoneNumber = '';
        }
        return phoneUtil.prettyPrint(primaryPhoneNumber, localeService.getDefaultCountryCode());
    };

    getPhoneNumberVisibility = (accountData) => {
        if (accountData.accountHolder.primaryPhoneType
            && (accountData.accountHolder.homeNumber || accountData.accountHolder.workNumber
                || accountData.accountHolder.cellNumber)) {
            return true;
        }
        return false;
    };

    render() {
        const { accountData, showEditLink, showNewQuoteButton } = this.state;
        if (_.isEmpty(accountData)) {
            return null;
        }
        const policySummaryArray = this.getPolicyTable();

        const overrides = {
            policyTable: {
                data: policySummaryArray
            },
            name: {
                content: _.get(accountData, 'accountHolder.displayName')
            },
            addressline1: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine1', '-')
            },
            addressline2: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine2', '-')
            },
            addressline3: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine3', '-')
            },
            city: {
                content: _.get(accountData, 'accountHolder.primaryAddress.city')
            },
            noDataMessage: {
                visible: _.isEmpty(policySummaryArray)
            },
            stateAndPostalcode: {
                content: this.getAccountHolderStateandPostalCode(accountData)
            },
            renewals: {
                content: _.toString(accountData.numberOfOpenPolicyRenewals)
            },
            cancellations: {
                content: _.toString(accountData.numberOfOpenPolicyCancellations)
            },
            changes: {
                content: _.toString(accountData.numberOfOpenPolicyChanges)
            },
            accountStatus: {
                content: this.getAccountDisplayStatus(accountData)
            },
            phoneNumberLabel: {
                visible: this.getPhoneNumberVisibility(accountData)
            },
            phoneNumber: {
                content: this.getPhoneNumber(accountData),
                visible: this.getPhoneNumberVisibility(accountData)
            },
            showEditButton: {
                visible: showEditLink
            },
            newQuoteButton: {
                visible: showNewQuoteButton
            },
            producerCode: {
                content: _.get(accountData, 'producerCodes[0].displayValue')
            }
        };

        const resolvers = {
            resolveCallbackMap: {
                getCell: this.getCell,
                getProductImage: this.getProductImage,
                getPolicyNoLink: this.getPolicyNoLink,
                handleEditButtonClick: this.handleEditButtonClick,
                handleNewQuoteClick: this.handleNewQuoteClick,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortNumber: DatatableUtil.sortNumber
            },
            resolveValue: this.readValue,
            resolveClassNameMap: summaryStyles
        };

        return (
            <div className={cx(summaryStyles.summary)}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={accountData}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </div>
        );
    }
}
const Summary = withModalContext(SummaryWithoutModalContext);
export const SummaryComponent = Summary;
export default withIntl(withAuthenticationContext(withViewModelService(Summary)));
